import {connect} from 'react-redux';
import {createSelector} from 'reselect';
import {NextSectionBlock as Component} from './NextSectionBlock';
import {Utilities} from '@learningblocks/exp-constants';

const {DESIGN_SLIDE_TYPES, NOTEBOOK_SECTIONS} = Utilities;

export const NextSectionBlock = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);

function mapStateToProps(state) {
  return {
    ...getCompleteFromState(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    toNextSection: (section) => {
      // dispatch(setNoteBookSection(section));
    },
  };
}

const getComplete = ({notebook}) => {
  return notebook.designSection.allSlides.find(
    (slide) => slide.type === DESIGN_SLIDE_TYPES.TWO
  ).slideTree;
};
const getAllSections = ({notebook}) => notebook.sections;

const getCompleteFromState = createSelector(
  [getComplete, getAllSections],
  (slideTree, allSections) => {
    let nextSection = '',
      lastgroupNode = {current: false};
    const currentSection = allSections.find(
      (section) => section.current === true
    );
    const visible = currentSection.value === NOTEBOOK_SECTIONS.DESIGN;
    if (visible) {
      nextSection = allSections.find(
        (section) => section.number === currentSection.number + 1
      ).value;
      const lastSlideTree = slideTree[slideTree.length - 1];
      lastgroupNode =
        lastSlideTree.groupNodes[lastSlideTree.groupNodes.length - 1];
    }
    return {complete: lastgroupNode.current && visible, nextSection};
  }
);
